module.exports = __webpack_public_path__ + "img/行政.8e5011d5.png";